export default {"src":"/sg/_next/static/media/Returns&Refund.f3645f55.svg","height":85,"width":84,"blurWidth":0,"blurHeight":0};